import React from 'react';

import Text from './Text';

function Block({
  children,
  heading,
  description,
  className = null,
  descriptionClassName = null,
  secondary,
}) {
  return (
    <div
      className={`border rounded bg-white mb-4 ${!secondary ? 'border-pink' : ''} ${className ?? ''}`}>
      {(heading || description) && (
        <div className={`p-4 py-6 border-b ${!secondary ? 'border-pink' : ''}`}>
          <div className="">
            <Text ui="mars">{heading}</Text>
          </div>

          {description && (
            <div className="pt-1">
              <Text ui={descriptionClassName ?? 'jupiter'}>{description}</Text>
            </div>
          )}
        </div>
      )}

      {children}
    </div>
  );
}

export default Block;
